<template>
  <form :class="classes()" slot="name" @submit.prevent="handleSubmit">
    <div :class="`${el}__inputRow`">
      <BaseInput
        label="Passwort"
        type="password"
        name="password"
        v-model="formFields.password.value"
        :error="formFields.password.error"
        @input="clearError(formFields.password)"
        @iconClicked="trackClick('showPasswd')"
        clearable
      />
    </div>
    <PasswordStrength :class="`${el}__passwordStrength`" :password="formFields.password.value" />
    <div :class="`${el}__buttonRow`">
      <Button :label="$t('auth.resetPassword.form.button')" :loading="loading" submit />
    </div>
  </form>
</template>

<script>
import Vue from 'vue';
import BaseInput from '@/objects/Forms/BaseInput';
import Button from '@/objects/Button';
import { validateForm } from '@/helpers/formValidation';
import { passwordPattern } from '@/helpers/patterns';
import PasswordStrength from '@/components/PasswordStrength';
import { ROUTE_API_RESET_PASSWORD } from '@/constants/apiRoutes';

import { createTrackingData } from '@/helpers/tracking/utils/helpers';

export default {
  name: 'ResetPasswordForm',
  props: {},
  components: {
    BaseInput,
    Button,
    PasswordStrength,
  },
  data() {
    return {
      loading: false,
      el: 'c-resetPasswordForm',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
      formFields: {
        password: {
          value: '',
          error: null,
          pattern: {
            value: passwordPattern,
            message: this.$t('auth.register.form.error.password.formatted'),
          },
        },
      },
    };
  },
  methods: {
    clearError(field) {
      field.error = null;
    },
    handleSubmit(e) {
      const { isValid } = validateForm(e.target.elements, this.formFields);
      if (isValid) {
        this.resetPassword();
      }
    },
    resetPassword() {
      this.loading = true;

      const { token } = this.$route.params;
      const { password } = this.formFields;
      const formData = new FormData();
      const user = {
        password,
        token: {
          value: token,
        },
      };

      Object.keys(user).map((name) => {
        formData.append(`account[${name}]`, user[name].value);
      });

      Vue.axios
        .post(ROUTE_API_RESET_PASSWORD, formData)
        .then((response) => {
          const { status } = response;
          if (status === 200) {
            this.$emit('sent');
            this.trackClick('saveBtn');
          }
          this.loading = false;
        })
        .catch((err) => {
          const {
            data: { errors },
            status,
          } = err.response;

          if (status === 422) {
            Object.keys(errors).map((error) => {
              const type = errors[error][0];
              this.formFields['password'].error = this.$t(
                `auth.register.form.error.password.${type}`
              );
            });
          }
          if (status === 401) {
            this.formFields['password'].error = this.$t(
              `auth.register.form.error.email.notAvailable`
            );
          }
          this.loading = false;
        });
    },

    trackClick(clickedElement) {
      let labelText = 'PW-vergessen-S3_';
      let eventText = '';

      switch (clickedElement) {
        case 'showPasswd':
          eventText = 'element';
          labelText = labelText + 'click-' + 'Passwort Anzeigen';
          break;
        case 'saveBtn':
          eventText = 'button';
          labelText = labelText + 'btn-' + this.$t('auth.resetPassword.form.button');
          break;
      }

      createTrackingData('Anmelden', labelText, eventText);
    },
  },
};
</script>
